import type { ReactNode } from 'react';
import { createContext, use } from 'react';

import type { AppConfig } from './appConfig.ts';

const AppConfigContext = createContext<AppConfig | null>(null);

export function AppConfigProvider({ config, children }: { config: AppConfig; children: ReactNode }) {
    return <AppConfigContext value={config}>{children}</AppConfigContext>;
}

export function useAppConfig(): AppConfig {
    const ctx = use(AppConfigContext);

    if (!ctx) {
        throw new Error('useAppConfig must be used within AppConfigProvider');
    }

    return ctx;
}
